import { EventBus } from "../../../../static/js/event-bus.js";

import axios from "axios";

//按需加载
import {
  addDemolitionArea,
  editDemolitionArea,
  // addDemolitionArea
  deleteDemolition,
  getFileDetail,
  deleteFile,
} from "../../../../api/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      demolitionArea_show: true,
      demolitionArea_submit_disabled: false,

      form: {
        id: "",
        parentId: "",
        name: "",
        description: "",
        demolitionShared: false,
        uid: "", //标记对象id
        mType: "point", //标记类型。
        points: "", //线标记和区域标记的坐标点信息。
      },
      title: "新增",
      rules: {
        parentId: [
          {
            required: true,
            message: "请选择所属分类",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入征迁区域名称",
            trigger: "blur",
          },
        ],
        // position: [{
        // 	required: true,
        // 	message: '右键单击地图，输入经度,维度,高程',
        // 	trigger: 'blur'
        // }],
      },
      isEdit: false,
      data: {},

      predefineColors: [
        //颜色选择器
        "#ffffff",
        "#c71585",
        "#ff4500",
        "#ffd700",
        "#55e8a2",
        "#1ba784",
        "#00ced1",
        "#1e90ff",
        "#9932cd",
        "#000000",
      ],
      //请求后端标记目录树时，记得在顶部添加一项，{value: '0',label: '根目录'},保障下拉框至少有一项，且可以新建目录树。
      options: [],
      timeTik: "", //一个关于标记的计时器。
      //cartesian:''

      tempFileList: [],

      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  mounted() {
    this.initFormData();

    //标记功能

    //alert(3)
    //console.log(this.$GLOBAL.markDrawGraphicLayer2)
    EventBus.$on("updateCartesian2", (param) => {
      //当标记点移动时，根据标记的id获取到标记的表单信息并显现在表单上，方便准确定位和编辑、更新等。
      this.form.mType = param.mType;
      if (param.mType === "point") {
        this.form.position = param.cartesianXYZ;
      } else if (param.mType === "polyline" || param.mType === "polygon") {
        this.form.points = param.points;
      }

      //根据编辑对象的id找到对应标记列表里的数据项，对应进行编辑。
      // this.editDemolitionAreaByUid(param.graphic._uuid);
      // alert(param.mType)
      // console.log(param.cartesianXYZ);
      // console.log(55555555555555555);
      //alert(1);
    });
  },
  methods: {
    onSubmit() {
      let that = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //alert(1)
          /* 表单提交后2秒内不可重复点击 */
          this.demolitionArea_submit_disabled = true;
          let that = this;
          //console.log(this);
          setTimeout(function() {
            that.demolitionArea_submit_disabled = false;
          }, 2000);

          if (
            this.form.fileList !== undefined &&
            this.form.fileList.length > 0
          ) {
            // this.$refs.upload.submit(); //提交调用uploadFile函数
            this.form.fileData = this.form.fileList
              .map(function(elem, index) {
                return elem.id;
              })
              .join(","); //new formData对象
          }
          //axios请求编辑数据。
          let mreData = {
            projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
            pid: this.form.parentId,
            name: this.form.name,
            description: this.form.description || "",
            isShare: this.form.demolitionShared,
            id: this.form.id,
          };
          if (this.isEdit) {
            //alert(2)
            mreData.id = this.form.id;
            editDemolitionArea(mreData).then((res) => {
              if (res.data.success && res.data.code === 204) {
                this.form.fileList = [];
                that.$parent.initTreeData();
                that.$notify({
                  title: "已成功更新征迁区域信息。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert(
                  "修改征迁区域信息保存失败了，请再试一次吧~",
                  "编辑失败",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            });
          } else {
            addDemolitionArea(mreData).then((res) => {
              //console.log(JSON.parse(JSON.stringify(res)));

              if (res.data.success && res.data.code === 204) {
                this.form.fileList = [];
                //表单验证设置了下拉框必选，需要将未选择下拉框和选择根目录区分开，而目录树里的根目录parentId是'',不是'0'。数据库里parentId为0表示上级是根目录。
                // // 本地更新目录树
                // if (formData.parentId === '0') {
                // 	formData.parentId = '';
                // }
                // // 随机生成id(仅为前端模拟使用，正常场景应为后台数据库新增记录成功后返回的主键Id)
                // formData.id = Math.ceil(Math.random()*100)+30+"";
                // //新增目录树数据
                // this.$emit('add_demolitionArea', formData);

                // 改为：直接通知父组件刷新数据
                that.$parent.initTreeData();

                that.$notify({
                  title: "已成功新增征迁区域信息。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                //console.log(mreData);
                that.$alert(
                  "添加征迁区域信息失败了，请再试一次吧~",
                  "添加失败",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            });
          }
          this.demolitionArea_click();
        }
      });
    },
    handleChange(file, fileList) {
      //文件状态改变【添加文件、上传成功、上传失败】时调用此方法。
      // 下面这样写会导致一次上传一个以上的文件时，最后一个文件被删除并提示"当前文件已经存在"，所以先注释。
      // let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
      // if (existFile) {
      // 	this.$message.error('当前文件已经存在！');
      // 	fileList.pop();
      // }

      this.form.fileList = fileList;
      //只保留最后上传的三个文件。
      //this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      //文件验证【后缀名|文件类型、文件大小】应该写在这里。

      //不允许上传同名文件。如果后面改为允许的话，要注意排查删除同名文件的问题【根据名字找文件得改为根据文件id来找文件】。
      let existFile = this.form.fileList
        .slice(0, this.form.fileList.length - 1)
        .find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error(
          "您上传了同名文件：" + file.name + "，已为您移除。"
        );
        return false;
      }

      // console.log(file);
      //避免编辑表单时旧上传文件导致验证不通过。
      //if (file.name) {
      let FileExt = file.name.replace(/.+\./, "");

      if (
        [
          "jpg",
          "png",
          "txt",
          "zip",
          "rar",
          "pdf",
          "doc",
          "docx",
          "xls",
          "xlsx",
        ].indexOf(FileExt.toLowerCase()) === -1
      ) {
        this.$message.error(
          "此处只允许上传后缀名为jpg、png、txt、pdf、doc、docx、xls、xlsx、zip或rar的附件！"
        );
        return false;
      }
      //}

      //const fileSizeLimit = this.form.fileList.every(file => file.size / 1024 / 1024 <=200);
      //console.log(this.form.fileList.length);
      if (file.size > 200 * 1024 * 1024) {
        this.$message.error("上传的单个文件大小不能超过200MB！");
        return false;
      }

      //return false; //先return false，阻止默认的给列表添加文件项，上传成功后再调用代码给列表添加文件项。
    },

    uploadFile(param) {
      let that = this;
      let formData = new FormData();
      formData.append("file", param.file);
      //这里如果调用封装的axios流程，会因为header导致一些问题，因此这里直接用axios方法请求上传文件。
      axios
        .post("/baseIP/sysFileInfo/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then(function(res) {
          if (res.data.success && res.data.data) {
            // let fileObj = {
            // 	'name': param.file.name,
            // 	'url': '',
            // 	'id': res.data.data,
            // }
            // that.form.tempFileList.push(fileObj);
            that.form.fileList = that.form.fileList.map((i) => {
              if (i.name === param.file.name) {
                i.id = res.data.data;
              }
              return i;
            });
            param.onSuccess(); //返回promise，调用文件上传成功方法 :on-success="uploadSuccess"
            //return false;

            //获取文件详情
            // let fData={
            // 	id:parseInt(res.data.data)
            // }
            // getFileDetail(fData).then(response => {
            // 	console.log(JSON.parse(JSON.stringify(response)));
            // 	console.log('66666666666')
            // 	if(res.data.success&&res.data.data){
            // 	}
            // }).catch(function(err) {
            //	console.log(err)
            // 	console.log('上传文件失败')
            // })
          } else {
            // console.log(err);
            // console.log('文件 ' + param.file.name + ' 上传失败，请重新上传');
            //上传失败则从列表里删除该项
            that.form.fileList = that.form.fileList.filter((item, index) => {
              return item.name !== param.file.name && item.status !== "ready";
            });
            that.$alert(
              "文件 " + param.file.name + " 上传失败，请重新上传",
              "出错提示",
              {
                type: "error",
              }
            );
            param.onError();
          }
        })
        .catch(function(err) {
          // console.log(err);
          // console.log('上传失败，请重新上传2');

          //上传失败则从列表里删除该项
          that.form.fileList = that.form.fileList.filter((item, index) => {
            return item.name !== param.file.name && item.status !== "ready";
          });

          that.$alert("上传失败，请重新上传", "出错提示", {
            type: "error",
          });
          param.onError();
        });
    },
    handleExceed(files, fileList) {
      //上传文件数量超过限制数量时调用此方法。
      this.$message.warning(
        `最多上传3个文件，您上传了 ${files.length +
          fileList.length} 个文件，已超过此数量。`
      );
    },

    beforeRemove(file, fileList) {
      //删除文件前调用，若返回false或者返回Promise且被reject，则停止删除。
      if (file.status !== "ready") {
        this.$confirm(
          "您确定要从服务器删除文件 " + file.name + " 吗？",
          "确认提示",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "确认删除",
            cancelButtonText: "取消删除",
          }
        )
          .then(() => {
            this.handleRemove(file, fileList);
          })
          .catch(function(err) {
            console.log(err);
          });
        // .catch(action => {
        // 	this.$message({
        // 		type: 'info',
        // 		message: action === 'cancel' ?
        // 			'放弃保存并离开页面' : '停留在当前页面'
        // 	})
        // });

        //先return false；阻止默认的删除。在调用服务器删除文件接口成功后再调用handleRemove方法。
        return false;
      }
    },
    handleRemove(file, fileList) {
      let that = this;
      //从文件列表中移除文件时调用此方法。
      let fData = {
        id: file.id,
      };
      deleteFile(fData)
        .then((res) => {
          // console.log(JSON.parse(JSON.stringify(res)));
          // console.log('66666666666'+i)
          if (res.data.success && res.data.code === 204) {
            //alert('触发！');
            let tIndex = fileList.indexOf(file);
            if (tIndex > -1) {
              fileList.splice(tIndex, 1);
              this.form.fileList = fileList;
            }

            // console.log(999999999999999);
            // console.log(JSON.parse(JSON.stringify(file)));
            // console.log(JSON.parse(JSON.stringify(fileList)));
          } else {
            that.$alert("删除失败，请再试一次吧。", "出错提示", {
              type: "error",
            });
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    handlePreview(file) {
      let that = this;
      //点击文件列表中已上传的文件时调用此方法，可在此写预览文件内容的代码。
      //['jpg', 'png', 'txt', 'zip', 'rar', 'pdf', 'doc', 'docx', 'xls', 'xlsx']

      //如果是图片则预览，其它符合文件则下载。
      //当然，本页面现在只凭后缀名检测文件并不严谨，但目前先这样。
      let FileExt = file.name.replace(/.+\./, "");
      let fileUrl = "" + file.name;
      if (["jpg", "png"].indexOf(FileExt.toLowerCase()) !== -1) {
        //这里直接使用axios请求上传接口，方便设置responseType: 'blob'。
        axios({
          method: "get",
          url: "/baseIP/sysFileInfo/preview", // 请求地址
          responseType: "blob", // 设置接收格式为blob格式
          params: {
            id: file.id,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        }).then((res) => {
          // console.log(res)
          if (res.status === 200 && res.data) {
            const dataInfo = res.data;
            let reader = new window.FileReader();
            // 使用readAsArrayBuffer读取文件, result属性中将包含一个 ArrayBuffer 对象以表示所读取文件的数据
            reader.readAsArrayBuffer(dataInfo);
            reader.onload = function(e) {
              const result = e.target.result;
              const contentType = dataInfo.type;
              // 生成blob图片,需要参数(字节数组, 文件类型)
              const blob = new Blob([result], {
                type: contentType,
              });
              // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
              const url = window.URL.createObjectURL(blob);
              console.log(url); // 产生一个类似 blob:d3958f5c-0777-0845-9dcf-2cb28783acaf 这样的URL字符串
              that.dialogVisible = true;
              that.dialogImageUrl = url; // 将转换出来的路径赋值给变量，其实和上一步结合就可以
            };
            that.downloadFile(res);
          } else {
            this.$message.error("预览失败，请稍后再试。");
            return false;
          }
        });
      } else {
        //这里直接使用axios请求上传接口，方便设置responseType: 'blob'。
        axios({
          method: "get",
          url: "/baseIP/sysFileInfo/download", // 请求地址
          responseType: "blob", // 设置接收格式为blob格式
          params: {
            id: file.id,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        }).then((res) => {
          // console.log(res)
          if (res.status === 200 && res.data) {
            that.downloadFile(res);
          } else {
            this.$message.error("预览失败，请稍后再试。");
            return false;
          }
        });
      }
    },
    uploadSuccess(reponse, file, fileList) {
      //alert('触发！');
      console.log("触发！");
    },
    downloadFile(res) {
      let blob = new Blob([res.data], {
        type: "application/octet-stream;charset=UTF-8",
      });
      let contentDisposition = res.headers["content-disposition"];
      let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
      let result = patt.exec(contentDisposition);
      let filename = result[1];
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      let reg = /^["](.*)["]$/g;
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = decodeURI(filename.replace(reg, "$1")); //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放通过调用URL.createObjectURL()创建的URL对象。
    },
    addDemolition(fdata, mType = "point") {
      //fdata为目录选项数据。
      // console.log(JSON.parse(JSON.stringify(fdata)));
      if (fdata == undefined || fdata.length <= 0) {
        fdata = [];
      }
      this.isEdit = false;

      this.title = "新增";
      // if (mType === 'point') {
      // 	this.title = '新增点';
      // } else if (mType === 'polyline') {
      // 	this.title = '新增线';
      // } else if (mType === 'polygon') {
      // 	this.title = '新增区域';
      // } else {
      // 	this.title = '新增';
      // }

      this.initFormData();
      this.$refs.form.resetFields();
      fdata.unshift({
        text: "根分类",
        parentId: 0,
        id: 0,
        demolitionType: "directory",
      });
      this.options = fdata;
      // console.log(JSON.parse(JSON.stringify(this.options)));

      // 这里不需要标记点，所以先注释掉。
      // this.bindMourseClick(false, mType);
    },
    editDemolition(data, fdata) {
      console.log(fdata);
      let mType = data.demolitionType;
      if (fdata == undefined || fdata.length <= 0) {
        fdata = [];
      }
      // fdata.unshift({
      //   text: "根分类",
      //   parentId: 0,
      //   id: 0,
      //   demolitionType: "directory",
      // });

      if (!data.parentId) {
        data.parentId = "0";
      }
      if (!data.demolitionIconColor) {
        data.demolitionIconColor = this.$GLOBAL.default_markIconColor;
      }
      if (!data.demolitionTextColor) {
        data.demolitionTextColor = this.$GLOBAL.default_markTextColor;
      }
      data.mType = mType;
      console.log(data);
      let { title, id, parentId, areaTreeDto } = data;
      this.form.name = title;
      this.form.id = id;
      this.form.parentId = parentId;
      this.form.description =
        areaTreeDto == null ? "" : areaTreeDto.areaDescription || "";
      this.form.demolitionShared =
        areaTreeDto == null ? true : areaTreeDto.isShared || true;
      this.options = fdata;
      // this.form = data;
      this.data = data; //这个this.data是方便页面里的删除按钮传值的。
      this.isEdit = true;

      //this.form.mType = mType;
      //alert(this.form.mType)
      if (mType === "point") {
        // 	this.title = '编辑点';
        // } else if (mType === 'polyline') {
        // 	this.title = '编辑线';
        // } else if (mType === 'polygon') {
        // 	this.title = '编辑区域';
        // } else {
        this.title = "编辑";
      }
    },
    initFormData() {
      this.form = {
        id: "",
        parentId: "",
        name: "",
        description: "",
        demolitionShared: false,
        uid: "", //标记对象id
        mType: "point", //标记类型。
        points: "", //线标记和区域标记的坐标点信息。
      };
    },
    deleteDemolition() {
      if (this.data && this.data.id) {
        this.$parent.deleteDemolitionArea(this.data);
      } else {
        //console.log(this.data);
        this.$alert("删除失败，因为发生了数据错误", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    demolitionArea_click() {
      //alert("触发");
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      // this.$GLOBAL.markDrawGraphicLayer2.off(mars3d.EventType.drawCreated);
      // this.$GLOBAL.markDrawGraphicLayer2.off(mars3d.EventType.editMovePoint);

      this.$refs.form.resetFields();
      this.$emit("demolitionArea_close");
    },
    demolitionArea_clean() {
      //this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$parent.open_demolition_box = ""; //清除标记的时候先关闭新增标记表单，避免标记没了，信息还可以提交。
      this.$GLOBAL.markDrawGraphicLayer2.removeGraphic(
        this.$GLOBAL.markDrawGraphicLayerObj
      );

      //此处可以清除一下已上传的文件【因为标记并没有被保存】，但是this.data不能获取到信息？。
    },
    //图上拾取
    bindMourseClick(editDemolition, mType = "point") {
      this.$GLOBAL.map.setCursor(true);
      let that = this;
      // 	this.$GLOBAL.map.once(mars3d.EventType.click, function(event) {
      // 		that.$GLOBAL.map.setCursor(false);
      // 		var cartesian = event.cartesian;
      // 		var point = mars3d.LngLatPoint.fromCartesian(cartesian);
      // 		point.format(); //经度、纬度、高度

      // 		let currJD = point.lng;
      // 		let currWD = point.lat;
      // 		let currGD = point.alt;
      // 		console.log(currJD,currWD,currGD);
      // 		//end
      // 		// updateMarker();
      // 	});
      // console.log(this.$GLOBAL.markDrawGraphicLayer2);
      // console.log(222222222);

      if (!this.form.demolitionIconColor) {
        this.form.demolitionIconColor = this.$GLOBAL.default_markIconColor;
      }
      if (!this.form.demolitionTextColor) {
        this.form.demolitionTextColor = this.$GLOBAL.default_markTextColor;
      }
      this.form.mType = mType;

      //绑定标绘相关事件监听(可以自行加相关代码实现业务需求，此处主要做示例)
      //alert(mType);return false;
      //this.$GLOBAL.markDrawGraphicLayer2.off(mars3d.EventType.drawCreated);
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.unbindPopup(); //解绑右键菜单
        this.$GLOBAL.markDrawGraphicLayer2.on(
          mars3d.EventType.drawCreated,
          function(e) {
            //alert('1:'+that.form.mType)
            // console.log("Events");
            // console.log(that.$GLOBAL.markDrawGraphicLayer2);
            if (that.form.mType === "point") {
              // console.log('创建完成', e.graphic._position_draw);
              var point = mars3d.LngLatPoint.fromCartesian(
                e.graphic._position_draw
              );
              point.format(); //经度、纬度、高度

              let currJD = point.lng;
              let currWD = point.lat;
              let currGD = point.alt;
              let cartesianXYZ = currJD + "," + currWD + "," + currGD;
              EventBus.$emit("updateCartesian2", {
                cartesianXYZ: cartesianXYZ,
                graphic: e.graphic,
                mType: mType,
              });
              // alert(cartesianXYZ)
              // console.log(currJD,currWD,currGD);
            } else if (
              that.form.mType === "polyline" ||
              that.form.mType === "polygon"
            ) {
              //console.log('区域标记创建完成', e);
              let points = that.handleCartsian3Points(
                e.graphic._positions_draw
              );
              if (points) {
                EventBus.$emit("updateCartesian2", {
                  graphic: e.graphic,
                  mType: mType,
                  points: points,
                });
              } else {
                that.$alert(
                  "创建该征迁区域信息出错了，请再试一次吧~",
                  "错误提示",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
              //console.log('p1:',points);
            }
          }
        );
        this.$GLOBAL.markDrawGraphicLayer2.on(
          mars3d.EventType.editMovePoint,
          function(e) {
            //alert('2:'+that.form.mType)
            // console.log(e.graphic.options.type);
            // console.log(123123);
            if (that.form.mType === "point") {
              console.log("创建完成", e.graphic._position_draw);
              var point = mars3d.LngLatPoint.fromCartesian(
                e.graphic._position_draw
              );
              point.format(); //经度、纬度、高度

              let currJD = point.lng;
              let currWD = point.lat;
              let currGD = point.alt;
              let cartesianXYZ = currJD + "," + currWD + "," + currGD;
              EventBus.$emit("updateCartesian2", {
                cartesianXYZ: cartesianXYZ,
                graphic: e.graphic,
                mType: mType,
              });
              // alert(cartesianXYZ)
              // console.log(currJD,currWD,currGD);
              // } else if (that.form.mType === 'polyline' || that.form.mType === 'polygon') {
              // 	console.log('地图里编辑区域标记修改了点（鼠标左键松开时触发）', e);
              // 	let points = that.handleCartsian3Points(e.graphic._positions_draw);
              // 	if (points) {
              // 		EventBus.$emit('updateCartesian2', {
              // 			graphic: e.graphic,
              // 			mType: mType,
              // 			points: points,
              // 		})
              // 	} else {
              // 		that.$alert('修改该标记出错了，请先保存该标记，再尝试修改一次吧~', '错误提示', {
              // 			confirmButtonText: '确定',
              // 			type: 'error',
              // 			callback: action => {}
              // 		});
              // 	}
            }
          }
        );
      }

      if (!editDemolition) {
        let tempGL;
        if (mType === "point") {
          let fIconUrl =
            "/img/marker/mark" +
            this.form.demolitionIconColor.slice(1) +
            ".png";
          tempGL = this.$GLOBAL.markDrawGraphicLayer2.startDraw({
            type: "billboard",
            style: {
              image: fIconUrl,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              label: {
                //不需要文字时，去掉label配置即可
                //text: "可以同时支持文字",
                text: this.form.name,
                font_size: 26,
                font_family: "黑体",
                color: this.form.demolitionIconColor,
                outline: true,
                // outlineColor: "#000000",
                pixelOffsetY: -66,
                visibleDepth: false,
              },
              visibleDepth: false,
            },
          });
          // } else if (mType === 'polyline') {
          // 	this.$message({
          // 		message: '添加的每个线标记最多只能有70个点哦。',
          // 		type: 'success',
          // 		offset: 100,
          // 		showClose: true,
          // 		duration: 2600,
          // 	});
          // 	tempGL = this.$GLOBAL.markDrawGraphicLayer2.startDraw({
          // 		type: "polyline",
          // 		maxPointNum: 70, //可以限定最大点数，70个点绘制后自动结束
          // 		style: {
          // 			color: this.form.demolitionIconColor,
          // 			width: 3,
          // 			clampToGround: true,
          // 			visibleDepth: false,
          // 			label: {
          // 				text: '标记名称',
          // 				font_size: 26,
          //        font_family: "黑体",
          // 				color: this.form.demolitionTextColor,
          // 				clampToGround: true,
          // 				// distanceDisplayCondition: true,
          // 				// distanceDisplayCondition_far: 500000,
          // 				// distanceDisplayCondition_near: 0,
          // 				visibleDepth: false,
          // 			}
          // 		}
          // 	})
          // } else if (mType === 'polygon') {
          // 	this.$message({
          // 		message: '添加的每个区域标记最多只能有70个点哦。',
          // 		type: 'success',
          // 		offset: 100,
          // 		showClose: true,
          // 		duration: 2600,
          // 	});
          // 	tempGL = this.$GLOBAL.markDrawGraphicLayer2.startDraw({
          // 		type: "polygon",
          // 		maxPointNum: 70, //可以限定最大点数，70个点绘制后自动结束
          // 		style: {
          // 			color: this.form.demolitionIconColor,
          // 			opacity: 0.36,
          // 			outline: true,
          // 			outlineWidth: 2,
          // 			outlineColor: this.form.demolitionTextColor,
          // 			clampToGround: true,
          // 			visibleDepth: false,
          // 			opacity:0.1,
          // 			label: {
          // 				text: '标记名称',
          // 				font_size: 26,
          //        font_family: "黑体",
          // 				color: this.form.demolitionTextColor,
          // 				clampToGround: true,
          // 				visibleDepth: false,
          // 			}
          // 		}
          // 	})
        } else {
          this.$alert("征迁区域类型出错，请关闭弹窗重新操作~", "错误提示", {
            confirmButtonText: "确定",
            type: "error",
            callback: (action) => {},
          });
        }

        this.$GLOBAL.markDrawGraphicLayerObj = tempGL;
        this.form.uid = tempGL._id;
        // console.log(77777777777777777777);
        // console.log(tempGL);
        // console.log(JSON.parse(JSON.stringify(this.form)));
      }

      // this.$GLOBAL.markDrawGraphicLayerArray.push(tempGL);
      // console.log(this.$GLOBAL.markDrawGraphicLayerArray);
      // console.log(2222222222222222222222);
    },
    demolitionIconColorChange() {
      if (!this.form.demolitionIconColor) {
        this.form.demolitionIconColor = this.$GLOBAL.default_markIconColor;
      }
      if (this.form.mType === "point") {
        let iconUrl =
          "/img/marker/mark" + this.form.demolitionIconColor.slice(1) + ".png";
        this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
          style: {
            image: iconUrl,
            label: {
              color: this.form.demolitionIconColor,
            },
          },
        });
      } else if (this.form.mType === "polyline") {
        this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
          style: {
            color: this.form.demolitionIconColor,
            // label: {
            // 	color: this.form.demolitionIconColor,
            // }
          },
        });
      } else if (this.form.mType === "polygon") {
        this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
          style: {
            color: this.form.demolitionIconColor,
            // label: {
            // 	color: this.form.demolitionIconColor,
            // }
          },
        });
      }
    },
    demolitionTextColorChange() {
      if (!this.form.demolitionTextColor) {
        this.form.demolitionTextColor = this.$GLOBAL.default_markTextColor;
      }
      if (this.form.mType === "point") {
      } else if (this.form.mType === "polyline") {
        this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
          style: {
            label: {
              color: this.form.demolitionTextColor,
            },
          },
        });
      } else if (this.form.mType === "polygon") {
        this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
          style: {
            outlineColor: this.form.demolitionTextColor,
            label: {
              color: this.form.demolitionTextColor,
            },
          },
        });
      }
    },
    demolitionNameChange() {
      // let that = this;
      // //alert('触发！');
      // if (this.form.mType === "point") {
      //   this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
      //     style: {
      //       label: {
      //         text: this.form.name,
      //       },
      //     },
      //   });
      // } else if (this.form.mType === "polyline") {
      //   //alert(1)
      //   // let obj={
      //   // 	style: {
      //   // 		label: {
      //   // 			text: '123',
      //   // 		}
      //   // 	}
      //   // }
      //   // setTimeout(function(){
      //   // 	that.$GLOBAL.markDrawGraphicLayerObj.style.label.text=that.form.name;
      //   // 	console.log(1)
      //   // },500)
      //   // console.log(this.$GLOBAL.markDrawGraphicLayerObj);
      //   // console.log(123321);
      //   this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
      //     style: {
      //       label: {
      //         text: this.form.name,
      //       },
      //     },
      //   });
      // } else if (this.form.mType === "polygon") {
      //   //alert(2)
      //   // this.$GLOBAL.markDrawGraphicLayerObj.label.text=this.form.name;
      //   this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
      //     style: {
      //       label: {
      //         text: this.form.name,
      //       },
      //     },
      //   });
      // }
    },
    handleCartsian3Points(points) {
      let parr = [];
      for (let i = 0; i < points.length; i++) {
        let point = mars3d.LngLatPoint.fromCartesian(points[i]);
        point.format();
        parr.push(point.lng + "," + point.lat + "," + point.alt);
      }
      if (parr.length > 0) {
        return parr.join("|");
      } else {
        return "";
      }
    },
  },
  watch: {},
  destroyed() {
    //this.$GLOBAL.markDrawGraphicLayer2=null
    // 移除EventBus监听器。
    EventBus.$off("updateCartesian2");
  },
};
//console.log(localStorage.getItem(ColorPicker));
